import { useContext } from "react"
import { ItemsContext } from "../contexts/ItemsContext"


const Presentation=()=>{

    const {setPresentation}=useContext(ItemsContext)
    const handleClick=()=>{
        setPresentation(false)
    }

return(
        <div className="presentation">
               <h1 className="a">Enhance your productivity</h1>
               <h1 className="b">and organize your workflow</h1>
               <h1 className="c">with our easy-to-use</h1>
               <div className="d">
                    <div>
                    <h1 className="task">TaskRanger</h1>
                    </div>
                    <div className="management">
                    <p>TASK</p><p>MANAGEMENT</p><p>APPLICATION</p>
                    </div>
               </div>
               <button onClick={handleClick}>Get Started</button>
             
                    
        </div>
    )
}

export default Presentation